<template>
  <footer class="site-footer">
    <!-- 桌面端页脚 -->
    <div v-if="!isMobile" class="footer-desktop">
      <p>© 2025 Zbeacon {{ $t('footer.platform') }}. {{ $t('footer.rights') }}</p>
      <!-- 新增：公司地址与联系电话 -->
      <p class="company-info">
        公司地址：广东省深圳市宝安区新桥街道万丰社区宝安大道8208号雅居园320 |
        联系电话：18665886416
      </p>
      <p class="beian">
        <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025497229号-1</a>
        <span class="divider">|</span>
        <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030002008881" target="_blank">
          <img src="@/assets/beian.png" alt="备案图标" />
          粤公网安备44030002008881号
        </a>
      </p>
    </div>

    <!-- 手机端底部菜单 -->
    <div v-else class="footer-mobile">
      <div class="menu-item" @click="goContact">
        <i class="el-icon-phone-outline"></i>
        <span>{{ $t('footer.contact') }}</span>
      </div>

      <div class="menu-item" @click="scrollToTop">
        <i class="el-icon-arrow-up"></i>
        <span>{{ $t('footer.top') }}</span>
      </div>

      <div class="menu-item" @click="goHome">
        <i class="el-icon-house"></i>
        <span>{{ $t('footer.home') }}</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  computed: {
    isMobile() {
      return window.innerWidth <= 800
    }
  },
  methods: {
    goHome() {
      if (this.$route.path !== '/') this.$router.push('/')
    },
    goContact() {
      this.$router.push('/contact')
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.site-footer {
  background: #fff;
  border-top: 1px solid #eee;
  text-align: center;
  padding: 12px;
  color: #666;
}

.footer-desktop p {
  margin: 0;
  font-size: 14px;
}

.footer-desktop .beian {
  margin-top: 6px;
  font-size: 12px;
  color: #999;
}

.footer-desktop .beian a {
  color: #999;
  text-decoration: none;
}

.footer-desktop .beian a:hover {
  color: #409eff;
}

.footer-desktop .beian img {
  width: 14px;
  height: 14px;
  vertical-align: -2px;
  margin-right: 4px;
}

.footer-desktop .beian .divider {
  margin: 0 6px;
  color: #ccc;
}

.footer-mobile {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: #fff;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 999;
}

.menu-item {
  flex: 1;
  text-align: center;
  font-size: 12px;
  color: #666;
}

.menu-item i {
  display: block;
  font-size: 20px;
  margin-bottom: 4px;
}

.menu-item:active {
  color: #409eff;
}
</style>
